import { ApiRestService } from './../_services/api-rest.service';
import { ToastrService } from 'ngx-toastr';
import { RitornoPaginazione } from 'src/app/shared/models/RitornoPaginazione';
import { Circle_Marker } from './../../shared/models/Circle_Marker';
import { MarkerIconPath } from './../../shared/models/marker-icon-path';
import { PersonaleStoreService } from './../../Admin/_service/personale-store.service';
import { ServerPaginationService } from './../../shared/_services/server-pagination.service';
import { InterventiStoreService } from './../_services/interventi-store.service';
import { DatePipe, NgIf } from '@angular/common';
import { FiltriInterventi } from './../Models/FiltriInterventi';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Intervento } from '../Models/Intervento';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Persona } from './../../Admin/models/persona';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import { Marker } from 'src/app/shared/models/Marker';
import { InterventoComponent } from '../intervento/intervento.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { color } from 'd3-color';
import { ActivatedRoute, Router } from '@angular/router';
import {is} from "date-fns/locale";

@Component({
  selector: 'app-pianificazione-interventi',
  templateUrl: './pianificazione-interventi.component.html'
})
export class PianificazioneInterventiComponent implements OnInit {
  selezionati:boolean = true;
  programmatiData:boolean = true;
  programmati:boolean = true;
  programmatiAltrui:boolean = true;
  altrui:boolean = true;
  inlista:boolean = true;

  subscriptions: Subscription = new Subscription();
  collectionSize: number = 0;
  piaificazione: string;
  Interventi: Intervento[] = [];
  InterventiAltrui: Intervento[] = [];
  InterventiPianificati: Intervento[] = [];
  Markers: Marker[] = [];
  HiddenMarkers: Marker[] = [];
  managers: Persona[] = [];
  managerselezionati: Persona[] = [];
  comuni: any[] = [];
  comuniselezionati: any[] = [];
  visualizzaTutti: boolean = true;
  centerMaplat: number = 41.4910946;
  centerMaplon: number = 12.7142646;
  circleMarker: Circle_Marker = { latitude: 41.4910946, longitude: 12.7142646, radius: 50000, editable: true, circleDraggable: true, fillColor: "blue", fillOpacity:0.5};
  filtri: FiltriInterventi = new FiltriInterventi();
  submitted: boolean = false;
  page = 1;
  pageSize = 50;
  pagesizeserver = 4
  newpagegenerated = 1;
  utentidropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'fullName',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  comunidropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'comune',
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  constructor(
    private datepipe: DatePipe,
    private interventiStore: InterventiStoreService,
    private toastService: ToastrService,
    private personaleStore: PersonaleStoreService,
    private markerIconPath: MarkerIconPath,
    private apiRest: ApiRestService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    const today = new Date();
    this.filtri.inizio = this.datepipe.transform(new Date(today.getFullYear(), today.getMonth(), 1), 'yyyy-MM-dd');
    this.filtri.fine = this.datepipe.transform(new Date(today.getFullYear(), today.getMonth() + 1, 0), 'yyyy-MM-dd');
    this.refreshTable();
    this.subscriptions.add(this.interventiStore.$interventi.subscribe(x => this.updateInterventiList(x)));
    this.subscriptions.add(this.interventiStore.$interventiAltrui.subscribe(data => this.updateInterventiAltruiList(data)));
    this.subscriptions.add(this.personaleStore.$listaPersonale.subscribe((items) => {
      if (items && items !== null)
        this.managers = items.data;
    }));
  }
  updateInterventiList(items: RitornoPaginazione<Intervento[]>) {
    if (items && items != null) {
      this.collectionSize = items.total;
      items.data.forEach(intervento => {
        if (intervento.tipoObject && intervento.tipoObject.label == "6 mesi")
          intervento.bgcolor = 'rgba(0, 151, 19, 0.2)'
        if (intervento.tipoObject && intervento.tipoObject.label == "12 mesi")
          intervento.bgcolor = 'rgba(0, 19, 151, 0.2)'
        if (intervento.tipoObject && intervento.tipoObject.label == "Garanzia")
          intervento.bgcolor = 'rgba(151, 151, 19, 0.2)'
        if (intervento.tipoObject && intervento.tipoObject.label == "Intervento a pagamento")
          intervento.bgcolor = 'rgba(151, 0, 19, 0.2)'
        const idx = this.InterventiPianificati.findIndex(item => item.id === intervento.id);
        intervento.selected = idx > -1;
        const marker = this.getMarkerOfIntervento(intervento, true);
        this.Markers.push(marker);
      });
      this.Interventi = items.data;
    }
  }
  updateInterventiAltruiList(items: RitornoPaginazione<Intervento[]>) {
    if (items && items != null) {
      items.data.forEach(intervento => {
        const int_ind = this.Interventi.findIndex(item => item.id === intervento.id);
        if (int_ind < 0) {
          const idx = this.InterventiPianificati.findIndex(item => item.id === intervento.id);
          intervento.selected = idx > -1;
          this.Markers.push(this.getMarkerOfIntervento(intervento, false));
          this.InterventiAltrui.push(intervento);
        }
      });
    }
  }

  refreshTable() {
    this.filtri.periodo = true;
    this.filtri.lat = this.circleMarker.latitude;
    this.filtri.lon = this.circleMarker.longitude;
    this.filtri.raggio = this.circleMarker.radius / 1000;
    if (this.managerselezionati && this.managerselezionati != null && this.managerselezionati.length > 0)
      this.filtri.manager = this.managerselezionati[0].id;
    else
      this.filtri.manager = undefined;
    this.Markers = [];
    this.InterventiAltrui = [];
    this.Interventi = [];
    this.interventiStore.getInterventi(this.filtri,'Filtro');
    if(this.filtri.manager)
      this.interventiStore.getInterventiAltrui(this.filtri);
  }
  refreshTablebycomune(){
    if (this.comuniselezionati && this.comuniselezionati != null && this.comuniselezionati.length > 0){
      var selectedCountry = this.comuni.find(x => x.id == this.comuniselezionati[0].id);
      if (selectedCountry) {
        console.log(selectedCountry)
        this.circleMarker.latitude = selectedCountry.lat;
        this.circleMarker.longitude = selectedCountry.lon;
        this.centerMaplat = selectedCountry.lat;
        this.centerMaplon = selectedCountry.lon;
        this.refreshTable();
      }
    }
    //this.comuniselezionati=[];
  }
  filtroResponsabile(item: string) {
    if (item.length >= 3) {
      this.personaleStore.getListaPersonale(new RicercaPaginazione(item, 0, 1));
    }
  }
  filtroComune(item: string) {
    if (item.length >= 3) {
      this.apiRest.getComuni(item).subscribe(data=>this.comuni = data);
    }
  }
  onMarkerClick(value: Marker) {
    if (value.selected){
      this.deselezionaInterventoID(value.intervento, value);
    }else {
      this.selezionaInterventoID(value.intervento, value);
    }
  }
  onSelect(item: Intervento) {
    if (!item.selected)
      this.deselezionaIntervento(item);
    else
      this.selezionaIntervento(item);
  }
  selezionaInterventoID(id: number, marker?: Marker) {
    var selected: Intervento;
    if (marker.inLista)
      selected = this.Interventi.find(x => x.id === id);
    else
      selected = this.InterventiAltrui.find(x => x.id === id);
    this.selezionaIntervento(selected, marker);
  }
  deselezionaInterventoID(id: number, marker?: Marker) {
    var selected: Intervento;
    if (marker.inLista)
      selected = this.Interventi.find(x => x.id === id);
    else
      selected = this.InterventiAltrui.find(x => x.id === id);
    this.deselezionaIntervento(selected, marker);
  }
  selezionaIntervento(intervento: Intervento, marker?: Marker) {
    if (intervento && intervento != null) {
      intervento.selected = true;
      if (!this.InterventiPianificati || this.InterventiPianificati == null || this.InterventiPianificati.length < 1)
        this.InterventiPianificati = [];
      this.InterventiPianificati.push(intervento);
      if (!marker) {
        const markerselezionato = this.Markers.find(x => x.intervento == intervento.id);
        this.selezionaMarker(markerselezionato);
      } else
        this.selezionaMarker(marker);
    }
  }
  deselezionaIntervento(intervento: Intervento, marker?: Marker) {
    if (intervento && intervento != null) {
      intervento.selected = false;
      if (this.InterventiPianificati && this.InterventiPianificati != null && this.InterventiPianificati.length > 0) {
        const idx = this.InterventiPianificati.findIndex(x => x.id === intervento.id);
        if (idx > -1)
          this.InterventiPianificati.splice(idx, 1);
      }
      if (!marker) {
        const markerselezionato = this.Markers.find(x => x.intervento == intervento.id);
        this.deselezionaMarker(markerselezionato);
      } else
        this.deselezionaMarker(marker);
    }
  }
  selezionaMarker(Marker: Marker) {
    if (Marker && Marker != null) {
      Marker.selected = true;
      Marker.iconUrl = this.getMarkerIcon(Marker);
      Marker.visible = this.getMarkerVisibility(Marker);
    }
  }
  deselezionaMarker(Marker: Marker) {
    if (Marker && Marker != null) {
      Marker.selected = false;
      Marker.iconUrl = this.getMarkerIcon(Marker);
      Marker.visible = this.getMarkerVisibility(Marker);
    }
  }
  getMarkerOfIntervento(intervento: Intervento, inLista?:boolean): Marker {
    const marker: Marker = new Marker();
    marker.lat = intervento.sedeObject.lat;
    marker.lng = intervento.sedeObject.lon;
    marker.draggable = false;
    marker.selected = intervento.selected;
    marker.inLista = inLista;
    marker.intervento = intervento.id;
    marker.interventoObject = intervento;
    marker.pianificato = !(intervento.data_fine_prevista == null);
    marker.iconUrl = this.getMarkerIcon(marker);
    marker.visible = this.getMarkerVisibility(marker);
    return marker;
  }

  getMarkerIcon(Marker: Marker): string {
    if (Marker && Marker != null) {
      if (Marker.selected)
        return this.markerIconPath.getSelezionato();
      else if (this.piaificazione && Marker.interventoObject instanceof Intervento && Marker.pianificato && Marker.inLista && this.datepipe.transform(Marker.interventoObject.data_fine_prevista, 'yyyy-MM-dd') == this.datepipe.transform(this.piaificazione, 'yyyy-MM-dd'))
        return this.markerIconPath.getpianificatoData();
      else if (Marker.pianificato && Marker.inLista)
        return this.markerIconPath.getPianificato();
      else if (Marker.pianificato && !Marker.inLista)
        return this.markerIconPath.getPianificatoNonInLista();
      else if (Marker.inLista)
        return this.markerIconPath.getInLista();
      else
        return this.markerIconPath.getNonInLista();
    } else
      return this.markerIconPath.getInLista();
  }
  getMarkerVisibility(Marker: Marker): boolean {
    const progdata : boolean = this.piaificazione && Marker.interventoObject instanceof Intervento && Marker.interventoObject && Marker.pianificato && Marker.inLista && this.datepipe.transform(Marker.interventoObject.data_fine_prevista, 'yyyy-MM-dd') == this.datepipe.transform(this.piaificazione, 'yyyy-MM-dd');
    if (Marker && Marker != null) {
      if (Marker.selected )
        return this.selezionati;
      else if ( progdata)
        return this.programmatiData;
      else if ( Marker.pianificato && Marker.inLista && !progdata)
        return this.programmati;
      else if (Marker.pianificato && !Marker.inLista)
        return this.programmatiAltrui;
      else if (Marker.inLista)
        return this.inlista;
      else if(!Marker.inLista)
        return this.altrui;
      else
        return true;
    } else
      return true;
  }

  VisibilityChange(){
    this.Markers.forEach(item => {
      //item.iconUrl = this.getMarkerIcon(item);
      item.visible = this.getMarkerVisibility(item);
    })
  }

  centra(item: Intervento) {
    this.circleMarker.latitude = item.sedeObject.lat;
    this.circleMarker.longitude = item.sedeObject.lon;
    this.centerMaplat = item.sedeObject.lat;
    this.centerMaplon = item.sedeObject.lon;
    this.refreshTable();
  }
  save(dataPianificazione) {
    this.submitted = true;
    if(!this.managerselezionati || this.managerselezionati == null || this.managerselezionati.length <1)
      this.toastService.warning("Indicare un responsabile","Ooops!!");
    else if(!dataPianificazione.valid)
      this.toastService.warning("Indicare una data di pianificazione","Ooops!!");
    else if(!this.InterventiPianificati || this.InterventiPianificati == null || this.InterventiPianificati.length <1)
      this.toastService.warning("Nessun intervento selezionato per la pianificazione","Ooops!!");
    else {
      const Result: Intervento[] = [];
      this.InterventiPianificati.forEach(item=>{
        Result.push(new Intervento(item.id,this.piaificazione, this.filtri.manager = this.managerselezionati[0].id));
      })
      this.apiRest.pianificaInterventi({fasi:Result}).subscribe(()=>{
        this.InterventiPianificati = [];
        this.refreshTable();
      });
    }
  }
  listClick(item){
      this.interventiStore.updateInterventoSelezionato(item);
      this.interventiStore.updateEditable(true);
      this.interventiStore.updateShowAddForm(false);
      this.interventiStore.updateIsModal(true);
      this.openInterventoForm();
  }
  openInterventoForm() {
    this.modalService.open(InterventoComponent, {
      centered: true,
      backdrop: 'static',
      size: 'lg',
    });
  }


  dataPianificazioneCambiata(){
    this.Markers.forEach(item => {
        item.iconUrl = this.getMarkerIcon(item);
        item.visible = this.getMarkerVisibility(item);
      })
      if(this.piaificazione)
        this.interventiStore.updateDataPianificazione(this.piaificazione);
  }
  vistaGiornaliera(){
    this.router.navigate([this.route.snapshot.queryParams[' interventi/giornalieri '] || 'interventi/giornalieri',]);


  }

}
